import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react';
import Shell from './components/layout/Shell.js';
import Dashboard from './pages/Dashboard.js';
import Companies from './pages/Companies.js';
import NotFound from './pages/NotFound.js';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Protected routes — redirect to sign-in if not authenticated */}
        <Route
          path="/*"
          element={
            <>
              <SignedIn>
                <Shell>
                  <Routes>
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route path="companies" element={<Companies />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Shell>
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn />
              </SignedOut>
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
